import { GetPresignedUrl } from 'domain/usecases/surgical-order/get-presigned-url'
import { GetPresignedUrlCrmo } from 'domain/usecases/surgical-order/get-presigned-url-crmo'
import { ApiStatusCode } from 'service/protocols/api/api-client'
import { IApiRepository } from 'service/protocols/api/api-repository'
import handleGraphQLError from 'repository/graphql/utils/handle-error'
import { RepositoryErrors } from 'repository/errors/repository-errors'

export class PresignedUrlRepository {
  constructor(private readonly apiRepository: IApiRepository) {}

  async getPresignedUrl(
    params: GetPresignedUrl.Params
  ): Promise<GetPresignedUrl.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<GetPresignedUrl.Model>

    const httpResponse = await apiRepository.post({
      url: '/generate-presigned-url-surgical',
      body: params
    })

    if (
      httpResponse.statusCode !== ApiStatusCode.ok &&
      httpResponse.statusCode !== ApiStatusCode.created
    ) {
      throw handleGraphQLError(RepositoryErrors[httpResponse.error!])
    }

    return httpResponse.body as GetPresignedUrl.Model
  }

  async getPresignedUrlCrmo(
    params: GetPresignedUrlCrmo.Params
  ): Promise<GetPresignedUrlCrmo.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<GetPresignedUrlCrmo.Model>

    const httpResponse = await apiRepository.post({
      url: '/generate-presigned-url-crmo',
      body: params
    })

    if (
      httpResponse.statusCode !== ApiStatusCode.ok &&
      httpResponse.statusCode !== ApiStatusCode.created
    ) {
      throw handleGraphQLError(RepositoryErrors[httpResponse.error!])
    }

    return httpResponse.body as GetPresignedUrlCrmo.Model
  }
}
